/**
 * Only same-origin paths are followed after sign-in, so a crafted
 * `?redirect=https://evil.example` cannot bounce a signed-in user off-site.
 */
export function safeRedirect(target: string | undefined, fallback = '/'): string {
  if (!target) return fallback;
  try {
    const url = new URL(target, window.location.origin);
    if (url.origin !== window.location.origin) return fallback;
    if (url.pathname.startsWith('/login') || url.pathname.startsWith('/reset-password'))
      return fallback;
    return url.pathname + url.search + url.hash;
  } catch {
    return fallback;
  }
}
